import { Component, Input } from '@angular/core';
import { ComplianceLimitsResult } from 'src/app/dtos/compliance-limits-result.dto';
import { NplexAnswersCombinedResult } from 'src/app/dtos/nplex-answers-combined-result.dto';
import { DateUtility } from 'src/app/utilities/date-utility';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.css'],
})
export class SearchResultComponent {
  @Input()
  result!: NplexAnswersCombinedResult;

  public constructor(private readonly dateUtility: DateUtility) {}

  public formatTransactionDate(transactionTs: string, pharmacyTimeZoneCode: string): string {
    // need a UTC timestamp with a 'Z' on the end
    const timestamp: string = transactionTs.endsWith('Z') ? transactionTs : `${transactionTs}Z`;
    
    return this.dateUtility.localizeUTCTimestamp(timestamp, pharmacyTimeZoneCode); 
  }

  public getActivityTypeColorClass(activityType: string): string {
    switch (activityType) {
      case 'BLOCKED':
        return 'border-2 rounded border-danger';
      case 'PURCHASE':
        return 'border-2 rounded border-success';
      case 'RETURN':
        return 'border-2 rounded border-corn';
      default:
        return 'border-2 rounded border-success';
    }
  }

  public getFederalLimits(
    result: NplexAnswersCombinedResult
  ): ComplianceLimitsResult[] {
    const limits: ComplianceLimitsResult[] = [];
    for (let limit of result.complianceLimitsResult) {
      if (limit.stateCd === null && limit.siteList === null) {
        limits.push(limit);
      }
    }

    return limits;
  }

  public getStateLimits(
    result: NplexAnswersCombinedResult
  ): ComplianceLimitsResult[] {
    const limits: ComplianceLimitsResult[] = [];
    for (let limit of result.complianceLimitsResult) {
      if (limit.stateCd !== null) {
        limits.push(limit);
      }
    }

    return limits;
  }

  public getSiteLimits(
    result: NplexAnswersCombinedResult
  ): ComplianceLimitsResult[] {
    const limits: ComplianceLimitsResult[] = [];
    for (let limit of result.complianceLimitsResult) {
      if (limit.siteList !== null) {
        limits.push(limit);
      }
    }

    return limits;
  }
}
